module.exports = __webpack_public_path__ + "static/media/microsoft-edge-icon.a6915d54.jpg";